/**
 * Emits a synthetic "encrypted" event for the player.
 *
 * Note that this function needs to be called via `.call`, `.apply` or `.bind`
 * in order to correctly set the `this` value.
 *
 * @param this - The HTMLMediaElement that will be the target of the encrypted
 *   event.
 * @param ev - The native encrypted event.
 */
export function emitEncrypted(ev) {
    const event = document.createEvent('Event');
    event.initEvent('encrypted', false, false);
    event.initDataType = 'cenc';
    event.initData = ev.initData;
    event.fromPolyfill = true;
    this.dispatchEvent(event);
}
//# sourceMappingURL=emit_encrypted.js.map